import { UserPermissionGroup } from "@/models/constants";

export const arrayContainElement = arrayValue => {
  return arrayValue && arrayValue !== null;
};

export const allowedPermission = (
  currentUserPermission,
  permissionGroup,
  permission
) => {
  return (
    arrayContainElement(currentUserPermission) &&
    currentUserPermission[permissionGroup].includes(permission)
  );
};

export const allowToViewCustomerNotes = currentUserPermission => {
  return allowedPermission(
    currentUserPermission,
    UserPermissionGroup.AirportTransferReservation,
    "ViewCustomerNote"
  );
};

export const allowToViewAdminNotes = currentUserPermission => {
  return allowedPermission(
    currentUserPermission,
    UserPermissionGroup.AirportTransferReservation,
    "ViewAdminNote"
  );
};

export const allowToAddEditAdminNotes = currentUserPermission => {
  return allowedPermission(
    currentUserPermission,
    UserPermissionGroup.AirportTransferReservation,
    "AddEditAdminNote"
  );
};

export const allowRepricingAirportTransfer = currentUserPermission => {
  return (
    allowedPermission(
      currentUserPermission,
      UserPermissionGroup.AirportTransferReservation,
      "Reprice"
    ) &&
    allowedPermission(
      currentUserPermission,
      UserPermissionGroup.AirportTransferReservation,
      "ViewRepriceHistory"
    )
  );
};

export const allowRepricingHourly = currentUserPermission => {
  return (
    allowedPermission(
      currentUserPermission,
      UserPermissionGroup.HourlyReservation,
      "Reprice"
    ) &&
    allowedPermission(
      currentUserPermission,
      UserPermissionGroup.HourlyReservation,
      "ViewRepriceHistory"
    )
  );
};

export const companySelectorAirportTransfer = currentUserPermission => {
  return allowedPermission(
    currentUserPermission,
    UserPermissionGroup.InquiryAvailability,
    "CompanySelector"
  );
};

export const companySelectorHourly = currentUserPermission => {
  return allowedPermission(
    currentUserPermission,
    UserPermissionGroup.InstantAvailability,
    "CompanySelector"
  );
};



// WEBPACK FOOTER //
// ./src/helpers/userHelper.js